export const FETCH_ALLEXAMS_REQUEST = 'FETCH_ALLEXAMS_REQUEST'
export const FETCH_ALLEXAMS_SUCCESS = 'FETCH_ALLEXAMS_SUCCESS'
export const FETCH_ALLEXAMS_FALIURE = 'FETCH_ALLEXAMS_FALIURE'
